
import { preventBodyScroll } from 'CommonUtils/preventBodyScroll.js';
import './ai-btn.css';
import {loadBtn} from './assistant_btn';
import {loadChatPopup} from './assistant_popup';
import {requestAnimationFrame} from 'CommonUtils/raf.js';
import { localSaveRaw, localLoadRaw, sessionLoad } from '../../storageService';
import { logMessage } from '../../js/common/logger';

export const isMob = window.innerWidth < 628 ;
export const chatBubble_display =  localLoadRaw('ai_assistant_bubble') ? false : true;
let fxnet_iframe = document.body.dataset.pageName === 'iframe-ai';

const assistant_container = document.createElement('div');
assistant_container.id = 'ai_assistant_container';

const params = new URLSearchParams(window.location.search);
const openChatParam = params.get("openChat");


function initAssistant(){
    !fxnet_iframe && loadBtn(assistant_container);
    loadChatPopup(assistant_container);
    document.body.appendChild(assistant_container);
    import(/* webpackChunkName: "ai-chat" */ '../chatGPT/chatGPTV2-assistant')
            .then(() => {
                openChatParam && document.getElementById('ai-chat-popup').classList.toggle('open'); 
                console.log('chat is loaded');
               
            });
}

initAssistant();

if(!fxnet_iframe){

  const chat_popup = document.getElementById('ai-chat-popup');
  const chat_bubble = document.getElementById('ai-chat-bubble');
  const chat_bubble_close = document.getElementById('ai-chat-bubble-close');
  const chat_fixed_button = document.getElementById('ai-fixed-btn');
  const ai_count = document.getElementById('ai-count');
  const cookie_notif = document.getElementById('cookie-notif');

  function toggleElemHeight(elem, fixed) {
      if (elem.style.height) {
          elem.style.height = fixed ? '100%' : elem.scrollHeight + 'px';
              elem.style.height = '0px';
          elem.addEventListener('transitionend', () => elem.style.height = '', { once: true });
      } else {
          elem.style.height = fixed ? '100%' : elem.scrollHeight + 'px';
      }
    }

  document.querySelectorAll('.aiChatToggle').forEach((elem) => {
    elem.onclick = function () {
      
      

        if(isMob){
            toggleElemHeight(chat_popup,true);
            document.getElementById('slidemenu').classList.remove('open');
            document.body.classList.remove("modal-open");
        }
            
        
        chat_popup.classList.toggle('open');
        preventBodyScroll();

        let data_log = elem.dataset.log ;

        logMessage({eid: chat_popup.classList.contains('open') ? data_log ? data_log : 'PopupAIAppear' : 'PopupCloseX'})

        const ul_chat = document.getElementById('all-messages');

        if (ul_chat && ul_chat.querySelector('li')) {
          const element = document.querySelector('.ai-chat-popup-body');
          element.scrollTop = element.scrollHeight;
        }
        


    };
        
  });



  function removeBubble() {
      chat_bubble.style.display = 'none';
      ai_count.style.display = 'none';
      chat_fixed_button.removeEventListener("click", removeBubble);
      const now = new Date();
      const expiryTime = now.getTime() + 90 * 24 * 60 * 60 * 1000; // 90 days in ms
      localSaveRaw(`ai_assistant_bubble`,expiryTime)
    }
    
    chatBubble_display && [chat_fixed_button, chat_bubble_close].forEach(el =>
      el.addEventListener("click", removeBubble)
    );

    chat_fixed_button.addEventListener("click", () => {
      logMessage({eid:'WidgetAIClick'})
    })

    function setBtnBottomPosition(){
      if(cookie_notif){
        setTimeout(() => {
          document.getElementById('ai_assistant_container').style.bottom = cookie_notif.offsetHeight + 20 + 'px';
        }, "2000");
      }
    }

    setBtnBottomPosition();

    window.addEventListener('resize', function() {
      setBtnBottomPosition();
    });

}

  document.querySelectorAll('.disclaimerContentToggle').forEach((elem) => {
    elem.onclick = function () {
        //toggleElemHeight(document.getElementById('ai-disclaimer-content'),false);
         document.getElementById('ai-chat-popup-disclaimer').classList.toggle('open');
      };
  });


